import React, { useState } from "react";
import styles from "./style/HowItWorks.module.css";
import { Link } from "react-router-dom";
import AnimateOnScroll from "../../../utils/commoncomponent/AnimateOnScroll";

import howimg1 from "../../../assets/frontendpage/home/how1.png";
import howimg2 from "../../../assets/frontendpage/home/how2.png";
import howimg3 from "../../../assets/frontendpage/home/how3.png";
import howimg4 from "../../../assets/frontendpage/home/how4.png";
import howimg5 from "../../../assets/frontendpage/home/how5.png";
import howimg6 from "../../../assets/frontendpage/home/how6.png";

const HowItWorks = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  // const [showFloatingChat, setShowFloatingChat] = useState(false);

  const handleChatnow = () => {
    setIsModalOpen(true);
  };

  // /* ✅ Scroll logic  */
  // useEffect(() => {
  //   const handleScroll = () => {
  //     const scrollTop = window.scrollY;
  //     const docHeight =
  //       document.documentElement.scrollHeight - window.innerHeight;

  //     if (docHeight <= 0) return;

  //     const scrollRatio = scrollTop / docHeight;

  //     // Show floating chat after 50%
  //     if (scrollRatio >= 0.5) {
  //       setShowFloatingChat(true);
  //     } else {
  //       setShowFloatingChat(false);
  //       setIsModalOpen(false); // close if user scrolls back up
  //     }

  //     // Auto-close modal when user reaches bottom 50%
  //     if (scrollRatio >= 0.9 && isModalOpen) {
  //       setIsModalOpen(false);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, [isModalOpen]);

  return (
    <section className={styles.howitworksContainer}>
      {/* Header */}
      <AnimateOnScroll animation="fadeUp">
        <div className={styles.firstDetail}>
          <h2>
            Online Learning With <br />
            <span>Book My Tuitions</span>
          </h2>
          <p>
            We connect students with verified tutors and institutions to ensure
            quality education and measurable outcomes.
          </p>
        </div>
      </AnimateOnScroll>

      {/* Features */}
      <div className={styles.howitworksGrid}>
        {[
          {
            img: howimg1,
            title: "Dedicated Educators",
            desc: "Committed teachers focused on student success.",
          },
          {
            img: howimg2,
            title: "Book Demo Class",
            desc: "Choose a subject and attend a free demo class.",
          },
          {
            img: howimg3,
            title: "Subject Experts",
            desc: "Specialists across academics and skills.",
          },
          {
            img: howimg4,
            title: "Diverse Sessions",
            desc: "From primary classes to advanced subjects.",
          },
          {
            img: howimg5,
            title: "Experienced Tutors",
            desc: "India’s best tutors with proven experience.",
          },
          {
            img: howimg6,
            title: "Student Results",
            desc: "We track progress and value feedback.",
          },
        ].map((item, index) => (
          <AnimateOnScroll key={index} animation="fadeUp" delay={index * 70}>
            <div className={styles.card}>
              <div className={styles.cardIconWrap}>
                <img src={item.img} alt={item.title} />
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </AnimateOnScroll>
        ))}
      </div>

      {/* Floating Chat Button */}
      {/* {showFloatingChat && (
        <button
          className={styles.floatingChat}
          onClick={handleChatnow}
          aria-label="Chat with Book My Tuitions"
        >
          💬 Chat
        </button>
      )} */}

      {/* Chat Modal */}
      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <button
              className={styles.closeButton}
              onClick={() => setIsModalOpen(false)}
            >
              ✕
            </button>

            <h3>Book My Tuitions Support</h3>
            <p className={styles.botText}>
              Hi! I’m your virtual assistant. How can we help you today?
            </p>

            <div className={styles.quickQuestions}>
              <Link to="/signup-as-student" className={styles.quickLink}>
                Find a Tutor
              </Link>

              <Link to="/signup-as-student" className={styles.quickLink}>
                Book a Demo Class
              </Link>

              <Link to="/signup-as-institution" className={styles.quickLink}>
                Partner With Us
              </Link>
            </div>

            <textarea
              className={styles.textareaField}
              placeholder="Type your message here..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />

            <p className={styles.notice}>
              Automated responses may not always be accurate.
            </p>
          </div>
        </div>
      )}
    </section>
  );
};

export default HowItWorks;
